// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import {load} from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/reviews/reviews';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/size-guide/size-guide';
import 'snippets/product-upsell/product-upsell';
import 'snippets/card-tags/card-tags';
import 'snippets/pre-order/pre-order';
import 'snippets/product-form/product-form';
import 'snippets/color-swatches/color-swatches';

import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/product/product';
import 'sections/value-bar/value-proposition-bar';
import 'sections/product-highlights/product-highlights';
import 'sections/product-specs/product-specs';
import 'sections/product-accordion/product-accordion';
import 'sections/service-bar/service-bar';
import 'sections/product-reviews/product-reviews';
import 'sections/product-recommendations/product-recommendations';

// Styles
import './_product.scss';


// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});
